<h1 mat-dialog-title>Time Travel</h1>
<div mat-dialog-content align="center">

  <mat-form-field>
    <mat-label>Travel to</mat-label>
    <input matInput [ngxMatDatetimePicker]="picker" [formControl]="dateControl">
    <mat-datepicker-toggle matSuffix [for]="$any(picker)"></mat-datepicker-toggle>
    <ngx-mat-datetime-picker #picker [showSpinners]="true" [showSeconds]="false" [enableMeridian]="false"
      [hideTime]="false">
    </ngx-mat-datetime-picker>
  </mat-form-field>
</div>
<div mat-dialog-actions align="center">
  <button mat-button (click)="close()">Ok</button>
</div>
